@if (vms$ | async; as vms) {
    <ms-option-group-list
        *ngFor="let vm of vms | slice: 0 : limit; trackBy: trackByEventId"
        [event]="vm.eventModel"
        [optionGroups]="vm.preparedOptionGoups"
        [showEventName]="true"
        [showEventTimer]="true"
        [showEventChevron]="true"
        [toggleable]="false"
        [showMoreCounter]="true"
        [optionsLimitOverride]="pod.optionsBeforeShowMore"
        [babButtonSource]="babButtonSource"
        [betBuilderEpcotEnabled]="babEpcotEnabled"
        [isLinkToEvent]="pod.enableTitleLink"
        [tracking]="tracking"
        [trackingModuleType]="trackingModuleType"
        [forceSingleColumn]="true" />
    <ms-top-events-show-more-less-button
        *ngIf="contentRendered && pod.eventsBeforeShowMore && vms$.value.length > pod.eventsBeforeShowMore"
        [currentLength]="limit"
        [totalLength]="vms$.value.length"
        (showMoreClicked)="showHideEvents($event)" />
    <div class="all-markets-link" *ngIf="contentRendered && link && limit >= vms$.value.length">
        <ms-item [href]="link.url" [tracking]="undefined" (itemClicked)="trackBottomLink()">
            <span class="title" item-title [innerHtml]="link.text || sitecore.event.ShowMore | msTrust: 'html'"></span>
        </ms-item>
    </div>
}
